import React from 'react';
import PropTypes from 'prop-types';
import { withPrefix } from 'gatsby';
const StaticImage = (props) => {
    const { src, ...rest } = props;
    return <img src={withPrefix(src)} {...rest} alt="" />;
};

StaticImage.propTypes = {
    src: PropTypes.string.isRequired,
};

export default StaticImage;
